const RemixLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 102 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="skill-icon"
    >
      <g clipPath="url(#clip0_102_65)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.5195 90.228C98.5754 103.746 98.5754 110.083 98.5754 117H67.1949C67.1949 115.493 67.222 114.115 67.2493 112.718C67.3342 108.373 67.4227 103.842 66.7164 94.6931C65.7831 81.2982 59.9959 78.3217 49.3548 78.3217H39.9272H0V53.9509H50.8484C64.2895 53.9509 71.0104 49.8754 71.0104 39.0852C71.0104 29.5973 64.2895 23.8477 50.8484 23.8477H0V0H56.4489C86.8784 0 102 14.3249 102 37.2075C102 54.3229 91.359 65.4851 76.9842 67.3455C89.1187 69.7639 96.2128 76.6474 97.5195 90.228Z"
          fill="#00E96C"
        />
        <path
          d="M0 117V98.8323H33.1803C38.7225 98.8323 39.9259 102.929 39.9259 105.373V117H0Z"
          fill="#00E96C"
        />
      </g>
      <defs>
        <clipPath id="clip0_102_65">
          <rect width="102" height="117" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RemixLogo;
